<template>
  <FITFormCard >
    <div slot='header'>
      <h4>{{this.label}}</h4>
    </div>
    <div slot="formBody">
      <div class="row mx-0 py-2">
        <CURDModal ref="CURDModals"></CURDModal>
        <b-col cols="auto">
          <FITButton v-bind="this.createBtn" @click="createAction()"></FITButton>
        </b-col>
        <b-col cols="3">
          <div class="form-group">
            <FITTextInput v-model="$v.contents.searchInput.value.$model" v-bind="contents.searchInput" @input="setSearch(contents.searchInput.value)"></FITTextInput>
          </div>
        </b-col>
        <b-col cols="auto" class="ml-auto">
          <b-row class="mx-0">
            <FITSelect class="pr-4" v-model="contents.rowsPerPage.value" v-bind="contents.rowsPerPage" @input="setPerPage(contents.rowsPerPage.value)"></FITSelect>
            <FITPagination v-model="contents.pagination.currentPage" :perPage="perPage" :totalRows="total" @input="setCurrentPage(contents.pagination.currentPage)"></FITPagination>
          </b-row>
        </b-col>
      </div>
      <div class="row mx-0 py-2">
        <b-table striped hover responsive :items="data" :fields="fields" :slots="slots" >
          <!-- Actions Column Slot -->
          <div :slot="contents.actions.key" slot-scope="row">
            <FITDropdown @clicked="dropdownAction(row.item.ID,$event)" variant="primary" :text="contents.actions.label" :options="contents.actions.options" ></FITDropdown>
          </div>
        </b-table>
      </div>
      <!-- Container Footer -->
      <div class="row mx-0 py-2">
        <b-col cols="auto" class="mr-auto align-self-center">
          <h5 class="d-block my-1">{{contents.totalItems.preFix}}: {{total}} {{contents.totalItems.postFix}}</h5>
        </b-col>
        <b-col cols="auto">
          <FITPagination v-model="contents.pagination.currentPage" :perPage="perPage" :totalRows="total" @input="setCurrentPage(contents.pagination.currentPage)"></FITPagination>
        </b-col>
      </div>
    </div>
  </FITFormCard>
</template>
<script type="text/javascript">
/* eslint-disable */ 
import Vue from 'vue'
import { FITCheckbox, FITTextInput, FITCheckboxGroup, FITRadio, FITTextarea, FITSelect, FITDatePicker, FITTimepicker, FITvSelect } from '@/components'
import { FITButton, FITDropdown, FITPagination, FITFormGroup, FITTable, FITFormCard } from '@/components'
import { required, minLength, between } from 'vuelidate/lib/validators'
import CURDModal from './CURDModal.vue'

var searchThread;

export default {
  name: 'ContainerTemplate',
  components: {
    FITButton,
    FITDropdown,
    FITTextInput,
    FITSelect,
    FITPagination,
    FITFormGroup,
    FITTable,
    FITFormCard,
    FITButton,
    CURDModal
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    createBtn: {
      type: Object,
      required: true,
    },
    vuex: Object // vuex initial value
  },
  data() {
    return {
      contents: {
        searchInput: { value: this.vuex.search, placeholder: this.$t("adm.contents.EntityManagement.search") },
        rowsPerPage: { value: this.vuex.perPage, options: this.vuex.perPageOptions, label: this.$t("adm.contents.EntityManagement.perPage") },
        pagination: { currentPage: this.vuex.currentPage },
        totalItems: { preFix: this.$t("adm.contents.EntityManagement.total"), postFix: this.$t("adm.contents.EntityManagement.records") },
        actions: {
          value: { rowID: '', action: '' },
          key: 'actions',
          label: 'Actions',
          options: [
            { key:'update', text: this.$t('general.CURD.update') },
            { key:'retrieve', text: this.$t('general.CURD.retrieve') },
            { key:'delete', text: this.$t('general.CURD.delete'),class:'text-danger' }
          ]
        }
      },
    }
  },

  created() {
    this.setCurrentPage(1);
  },
  computed: { // Get Realtime Vuex Value
    slots() {
      return this.vuex.addedColumns.Core;
    },
    fields() {
      // console.log(this.vuex.columns);
      // console.log(this.vuex.fields);
      return this.vuex.fields;
    },
    search() {
      return this.vuex.search;
    },

    perPage() {
      return this.vuex.perPage;
    },

    currentPage() {
      return this.vuex.currentPage;
    },

    total() {
      return this.vuex.total;
    },
    data() {
      return this.vuex.list;
    }
  },
  validations: {
    contents: {
      searchInput: {
        value: {
          required,
          minLength: minLength(5)
        }
      }
    },
  },
  mounted() {},
  methods: {
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    },
    setSearch(input) {
      var vm = this;
      clearTimeout(searchThread);
      searchThread = setTimeout(function() {
      vm.$store.commit({ type: 'EntityManagement/setSearch', search: input });
      vm.getDataList();
      }, 1000);
    },
    setPerPage(amount) {
      // console.log(amount);
      this.contents.rowsPerPage.value = amount;
      this.$store.commit({ type: 'EntityManagement/setPerPage', perPage: amount });
      this.contents.pagination.currentPage = 1;
      this.$store.commit({ type: 'EntityManagement/setCurrentPage', currentPage: 1 });
      this.getDataList();
    },
    setCurrentPage(currentPage) {
      // console.log(currentPage);
      this.contents.pagination.currentPage = currentPage;
      this.$store.commit({ type: 'EntityManagement/setCurrentPage', currentPage: currentPage });
      this.getDataList();
    },
    getDataList() {
      this.$store.dispatch('EntityManagement/getDataList');
    },
    dropdownAction(ID,action) {
      // this.contents.actions.value.rowID = value.ID;
      // console.log(ID);
      var object = {
        rowID: ID,
        action:action
      }
      this.showModal(object);
    },
    createAction(){
    // this.contents.actions.value.action = action;
    this.showModal({rowID:'',action:'create'})
    },
    showModal(object) {
      // console.log(object);
      this.$refs.CURDModals.openCURDModal(object);
    },

  }
}

</script>
<style type="text/css">
.ContainerTemplate {
  padding: 1rem 3rem;
  width: 100%;
  background-color: white;
}

.ContainerTemplate h4 {
  color: #555555;
}

</style>



// WEBPACK FOOTER //
// src/Adm/EntityManagement/components/ContainerTemplate.vue